import { useWebBooking } from "api/api-hooks/use-web-booking";
import { useMemo } from "react";
import { AvailableTimesSection } from "types/available-times";

const useOriginalSelectedTime = (section: AvailableTimesSection | null) => {
    const { data: booking } = useWebBooking();

    return useMemo(() => {
        if (!section || !booking?.articles) return undefined;

        const matchingTime = booking.getBookTimes().find((time) => time.sectionId === section.id);

        const matchingTimeSet = section.timeSets.find(
            (timeSet) => timeSet.id === matchingTime?.ruleId
        );
        return matchingTimeSet?.times.find((time) => time.start.isSame(matchingTime?.start));
    }, [section, booking]);
};

export { useOriginalSelectedTime };
